const SuspiciousCrews = () => import("@/views/other/SuspiciousCrews.vue")

export default [
    {
        path: "/admin/suspicious-crews",
        name: "SuspiciousCrews",
        component: SuspiciousCrews,
        meta: {
            label: "Suspicious crews"
        }
    }
]
